import React, { Component } from 'react'
import { get } from 'lodash'
import InputMessage from 'components/Input/InputMessage'
import InputValid from 'components/Input/InputValid'
import dropzone from 'react-dropzone'
import LoadingLinear from 'components/Loading/LoadingLinear'
import IconCloseThin from 'components/Icons/CloseThin'
import Button from 'components/Button/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

const Dropzone = dropzone.default

import cn from 'classnames'
import s from './FileInput.scss'
import sInput from 'components/Input/Input/Input.scss'
import config from 'src/config'

export default class Input extends Component {
  static defaultProps = {
    display: 'standard',
    uploadType: 'file', // || 'audio'
  }
  onDrop = filesToUpload => {
    const { uploadType, uploadFile, uploadAudio, input } = this.props
    const uploadFunc = uploadType === 'audio' ? uploadAudio : uploadFile
    uploadFunc({
      id: input.name,
      file: filesToUpload[0],
    }).then(({ value }) => {
      input.onChange({
        name: filesToUpload[0].name,
        id: value.data.hash,
      })
    })
  }
  render() {
    const {
      input,
      labelUp,
      label,
      disabled,
      children,
      color,
      hideDot,
      className,
      uploadType,
      loading,
      meta: { touched, error, warning, active },
    } = this.props
    const hasValue = input.value && input.value.id

    const outerClasses = cn(
      sInput.outer,
      { [sInput.invalid]: touched && error },
      { [sInput.inactive]: !hasValue && !labelUp },
      { [sInput.white]: color === 'white' },
      { [sInput.disabled]: disabled },
      sLay.flex
    )

    const inputClasses = cn(
      sInput.standard,
      { [sInput.white]: color === 'white' },
      s.input,
      sText.ellipsis,
      className
    )

    const labelClasses = cn(sInput.label)

    const fileId = get(input, 'value.id')
    const fileName = get(input, 'value.name')

    return (
      <div>
        <div className={sLay['layout-row']}>
          <div className={outerClasses}>
            <label htmlFor={input.name} className={labelClasses}>
              {label}
            </label>
            <Dropzone
              disabled={disabled}
              id={input.name}
              onDrop={this.onDrop}
              className={inputClasses}
            >
              {fileName}
            </Dropzone>
            {loading && <LoadingLinear style={{ marginTop: '-2px' }} />}
            <InputMessage error={error} warning={warning} touched={touched} />
            {!hideDot && <InputValid valid={!(error || warning) && !active && hasValue} />}
            {children}
          </div>
          {fileId && (
            <Button
              icon
              size="sm"
              onClick={() => input.onChange({})}
              title="Remove"
              style={{ marginTop: '22px', marginLeft: '10px' }}
            >
              <IconCloseThin size={24} />
            </Button>
          )}
        </div>
        {uploadType === 'audio' && fileId && (
          <audio controls style={{ width: '100%', marginBottom: '20px' }}>
            <source src={`${config.api.portal}/api/v1/twilio/media/${fileId}`} />
          </audio>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Files/FileInput/FileInput.jsx